export default {
  name: 'GoToCheckoutStep',
  methods: {
    goToStep (step) {
      this.$bus.$emit('checkout-set-active-section', step)
    }
  }
}
